import type { NodeSn } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { findNodeIdByNodeSn } from './helpers/findNodeIdByNodeSn';

export interface HighlightGraphNodeCommand {
  nodeSn: NodeSn;
}

export const highlightGraphNode: GraphCommandFactory<
  HighlightGraphNodeCommand
> = (cmdContext) => (command) => {
  const nodeId = findNodeIdByNodeSn(
    cmdContext.getState().graph,
    command.nodeSn,
  );
  cmdContext.updateState((draft) => {
    if (nodeId === null) {
      return;
    }
    cmdContext.eventEmitter.emit('nodeHighlight', { nodeId });
    draft.highlightedNodeId = findNodeIdByNodeSn(draft.graph, command.nodeSn);
  });
};
